import React, { useEffect, useState } from "react";

// reactstrap components
import { Card, CardBody, Table, Row, Col, Button,  Modal,
  ModalBody } from "reactstrap";
import { MDBInput } from "mdb-react-ui-kit";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import axios from "axios";
import apiService from "../../variables/apiService";
import {
  WHATSAPP_CAMPAIGN_LIST,
  WHATSAPP_CAMPAIGN_DELETE,
  CHANNEL_CLIENT_CHNLTYPE,
  WHATSAPP_OvERVIEW
} from "../../constants";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { ModalFooter } from "react-bootstrap";

let templates = [];
let senderids = [];
var initialvalues = {
  fromdate: "",
  todate: "",
  templateid: "",
  senderid: "",
};
const localJson = localStorage.getItem("user");
const user = JSON.parse(localJson);
const Campaignlist = () => {
  const [campaignList, setCampaignList] = useState([]);
  const [campaignListC, setCampaignListC] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const [search, setSearch] = useState(initialvalues);
  const [errorhandle, setErrorHandle] = useState();
  const [channel, setChannel] = useState([]);
  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });
  const [whatsappdetailLst, setWhatsappdetailLst] = useState([]);
  const [countModal,setCountModal] = useState(false)
  const notificationAlertRef = React.useRef(null);
  const [modalselectdata, setModalselectdata] = useState({});



  useEffect(() => {
    fetchChanelsbyClient();
    //getCampaginList(currentPage);
  }, []);

  const getCampaginList = async (page) => {
    const fromdate = moment(search?.fromdate).format("YYYY-MM-DD");
    const todate = moment(search?.todate).format("YYYY-MM-DD");
    const templateid = search?.templateid?.value;
    const senderid = search?.senderid?.value ||  user?.sender_id;


    if (fromdate&&todate) {
      setCurrentPage(page);
      setIsLoading(true);

      await apiService
        .getData(
          `${WHATSAPP_CAMPAIGN_LIST}?tempname=${templateid}&senderid=${senderid}&fromdate=${fromdate}&todate=${todate}&page=${page}`
        )
        .then((res) => {
          setCampaignList(res?.data);
          setCampaignListC(res?.data);
          setIsLoading(false);
        })
        .catch((error) => console.log("error", error))
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setErrorHandle({
        templateid: "Please Select from and to date",
      });
    }
  };

  const fetchChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          templates = [];

          setChannel(res?.data);

          res?.data?.map((item, i) => {
            item?.template &&
              templates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
          let options = {};
          options = {
            place: "tr",
            message: "Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

  const changeSender = (data) => {
    senderids = [];
    const chnl = channel?.filter((item) => item.template == data.value);

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] });
    }

    setSearch((prev) => ({ ...prev, templateid: data, senderid: "" }));
  };

  // const filteruser = (val) => {
  //   const filterobj = campaignListC?.message?.filter(
  //     (item) =>
  //       item.campaign.toLowerCase().includes(val.toLowerCase()) ||
  //       item.sdate.toLowerCase().includes(val.toLowerCase())
  //   );
  //   setCampaignList({
  //     message: filterobj,
  //   });
  // };

  const toDatevalidation = async (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };

  var valid = function (current) {
    var yesterday = moment().subtract(0, "day");

    return current.isBefore(yesterday);
  };

  const campaignoverview=(name,date,time)=>{
    setIsLoading(true);
    setModalselectdata({
      name:name,
      date:date,
      time:time
    })
    const payload={
      senderid:search?.senderid?.value ||user?.sender_id,
      campaign:name,
      fromdate:date
    }
    axios.post(WHATSAPP_OvERVIEW,payload).then(res=>{
    
setWhatsappdetailLst(res?.data)
setCountModal(true);
    }).catch(err=>{
      console.log(err);
     
      let options = {};
      options = {
        place: "tr",
        message: "Something went wrong",
        type: "warning",
        autoDismiss: 2,
      };
      notificationAlertRef?.current?.notificationAlert(options);
    }).finally(()=>{
      setIsLoading(false);
    })
  }

  return (
    <>
      <div className="content pb-0 ">
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                {alert}

                  {/* Modal for campaign report start */}

              {<Modal isOpen={countModal} toggle={()=>setCountModal(false)} className="detailedReport" >
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={()=>{setCountModal(false);setCurrentPage(1)}}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <p className="title title-up">{` ${modalselectdata?.name} ( ${modalselectdata?.date} ${modalselectdata?.time||""})`}</p>
            </div>
            <ModalBody className="modelbody ">
              <Row >

              <Table responsive stiped style={{height:"450px !important"}}>
                    <thead>
                      <tr>
                      <th>Sno </th>
                        <th> sent </th>
                        <th> deliver</th>
                        <th> read</th>
                        <th> failed </th>
                      </tr>
                    </thead>
                    <tbody>
                    {whatsappdetailLst?.message?.length > 0 ? (
                        whatsappdetailLst?.message?.map((item, index) => {
                         
                          return (
                            <>
                              <tr>
                                <td >{index + 1}</td>
                                <td >{item?.sent}</td>
                                <td >{item?.deliver}</td>
                                <td >{item?.readby}</td>
                                <td >{item?.failed}</td>
                              </tr>
                            </>
                          );
                        })
                      ) : (
                        <tr>
                          <td colspan="13">No Records Availble</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                
               
              </Row>
            </ModalBody>
            <ModalFooter>
            {whatsappdetailLst?.numOfPages > 0 && (
                <div style={{ width: "30%", marginLeft: "auto" }}>
                  <ResponsivePagination
                    current={currentPage}
                    total={whatsappdetailLst?.numOfPages}
                    onPageChange={(newPage) => {
                    
                    }}
                  />
                </div>
              )}
            </ModalFooter>
          </Modal>}
          {/* Modal for campaign report end */}
                <Row>
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                      }}
                      isValidDate={valid}
                    />
                    <span style={{ color: "red" }}>
                      {errorhandle?.fromdate}
                    </span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        toDatevalidation(val._d);
                      }}
                      isValidDate={valid}
                    />
                    <span style={{ color: "red" }}>{errorhandle?.todate}</span>
                    <span style={{ color: "red" }}>{validate?.message}</span>
                  </Col>

                  <Col md="3" sm="12">
                    <p className="category">
                      Select Template
                    </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="templateSelect"
                      value={search.templateid}
                      onChange={(value) => changeSender(value)}
                      options={templates}
                      placeholder="Select"
                    />
                    {/* {errorhandle?.templateid && (
                      <span style={{ color: "red" }}>
                        {errorhandle?.templateid}
                      </span>
                    )} */}
                  </Col>
                  <Col md="3" sm="12">
                    <p className="category">
                      Select Sender
                    </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="senderSelect"
                      value={search?.senderid}
                      onChange={(value) =>
                        setSearch((prev) => ({ ...prev, senderid: value }))
                      }
                      options={senderids}
                      placeholder="Select"
                    />
                    {/* {errorhandle?.sender && (
                      <span style={{ color: "red" }}>
                        {errorhandle?.sender}
                      </span>
                    )} */}
                  </Col>
                  <Col md="2" sm="12">
                    <Button
                      className="btn-icon btn btn-primary mt-4"
                      onClick={() => getCampaginList(currentPage)}
                    >
                      <i class="tim-icons icon-double-right"></i>
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-2 ">
              <CardBody>
                <LoadingScreen
                  children=""
                  loading={isLoading}
                  bgColor="rgba(0,0,0,0.7)"
                  spinnerColor="#9ee5f8"
                  textColor="#676767"
                  logoSrc={logo}
                  text="Loading..."
                ></LoadingScreen>
                <TableContainer component={Paper} className="tableheight">
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th>S no </th>
                        <th> Campaign Name</th>
                        <th> Schedule Date Time</th>
                        <th> Status</th>
                        <th> Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {campaignList?.message?.length > 0 ? (
                        campaignList?.message?.map((row, index) => (
                          <tr
                            key={index + 1}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td component="th" scope="row">{index + 1}</td>
                            <td>{row.campaign}</td>
                            <td> {row.sdate} {row.stime}</td>
                            <td>{row.status}</td>
                            <td onClick={()=>campaignoverview(row?.campaign,row?.sdate,row?.stime)}> <i className="tim-icons icon-tap-02" /></td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5}>No Records Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {campaignList?.numOfPages > 0 && (
          <div style={{ width: "30%", float: "right", padding: "8px" }}>
            <ResponsivePagination
              current={currentPage}
              total={campaignList?.numOfPages}
              onPageChange={(newPage) => {
                getCampaginList(newPage);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Campaignlist;
